import { PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const CreateLanguagePageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.languages.create.pageHeader.title')} />
}

CreateLanguagePageHeader.displayName = 'CreateLanguagePageHeader'
export default CreateLanguagePageHeader
